/**
 * Settings content — sub-tabs for Display, Import, and Storage.
 */

import { useState } from 'react';
import { BackupSection } from './backup-section';
import { BulkImportSection } from './bulk-import-section';
import { DataFolderSection } from './data-folder-section';
import { DisplaySection } from './display-section';
import { PdfRegenerateSection } from './pdf-regenerate-section';
import { ProvidersSection } from './providers-section';
import { ThemeSection } from './theme-section';
import { UpdatesSection } from './updates-section';
import { ImportContent } from '../import-content';
import { SubTabControl } from '../sub-tab-control';
import { isDesktop } from '@/desktop/desktop';

type SettingsSubTab = 'display' | 'import' | 'storage';

// Display (theme, font, reading mode) is everywhere — UAT 2026-08-26 pulled
// it back onto the web. Import + Storage manage user data, which is
// native-only (DESKTOP-PRD §3.8).
const ALL_ITEMS = [
  { value: 'display', label: 'Display' },
  { value: 'import', label: 'Import' },
  { value: 'storage', label: 'Storage' },
] as const;

export function SettingsContent() {
  const [active, setActive] = useState<SettingsSubTab>('display');
  const items = isDesktop() ? ALL_ITEMS : ALL_ITEMS.filter((i) => i.value === 'display');

  return (
    <div className="flex h-full flex-col">
      <SubTabControl items={items} active={active} onChange={setActive} />
      <div className="min-h-0 flex-1 overflow-y-auto">
        {active === 'display' && (
          <div className="space-y-6">
            <DisplaySection />
            <ThemeSection />
            {/* Visible the moment Settings opens — the update check is a
                member-facing control, not a buried admin toggle. */}
            {isDesktop() && <UpdatesSection />}
          </div>
        )}
        {isDesktop() && active === 'import' && <ImportContent />}
        {isDesktop() && active === 'storage' && (
          <div className="space-y-6">
            <DataFolderSection />
            <BackupSection />
            <ProvidersSection />
            <BulkImportSection />
            <PdfRegenerateSection />
          </div>
        )}
      </div>
    </div>
  );
}

export default SettingsContent;
